import { api, opportunityApi } from ".";

export interface Application {
    Id: number;
    Name: string;
    Description?: string;
    ClientId?: string;
    IsActive: boolean;
    CustomersCount: number;
    RolesCount: number;
    PrivilegesCount: number;
}

export interface ApplicationCustomers {
  AppId: number;
  CustomerIds: number[];
}

export interface ApplicationDefaultType {
  Id: number;
  ApplicationId: number;
  Name: string;
  IsActive: boolean;
}

export interface ApplicationCustomerDefaultSeed {
  Id: number;
  ApplicationCustomerId: number;
  ApplicationDefaultTypeId: number;
  Success: boolean;
  CreatedByUserId: number;
  CreatedDateUtc: string;
}

export interface ApplicationManifest {
  ClientId: string;
  Name: string;
}

const appUrlV1 = "/v1/Applications";
const appCustomersUrlV1 = "/v1/ApplicationCustomers";

export const getApplications = async () => {
  const response = await api.get<Application[]>(appUrlV1);
  return response?.data;
};

export const getOpenApiApplications = async () => {
  const response = await api.get<Application[]>(`${appUrlV1}/openApis`);
  return response?.data;
};

export const downloadApplicationManifest = async (appId: number) => {
  var response = await api.get<ApplicationManifest>(`${appUrlV1}/${appId}/manifest`);
  return response?.data;
};

export const getApplication = async (appId: number) => {
  const response = await api.get<Application>(`${appUrlV1}/${appId}`);
  return response?.data;
};

export const addApplication = async (app: Application) => {
  const response = await api.post(appUrlV1, app);
  return response?.data;
}

export const deleteApplication = async (appId: number) => {
  const response = await api.delete(`${appUrlV1}/${appId}`);
  return response?.status === 204;
}

export const updateApplication = async (appId: number, app: Application) => {
  const response = await api.put(`${appUrlV1}/${appId}`, app);
  return response?.status === 204;
}

export const addApplicationCustomers = async (appCustomer: ApplicationCustomers) => {
  const response = await api.post(`${appCustomersUrlV1}/AddAccess`, appCustomer);
  return response?.data;
}

export const removeApplicationCustomers = async (appCustomers: ApplicationCustomers) => {
  const response = await api.post(`${appCustomersUrlV1}/RemoveAccess`, {...appCustomers, IsActive: false});
  return response?.data;
}

export const getApplicationDefaultTypes = async (appId: number) => {
  const response = await api.get<ApplicationDefaultType[]>(`${appCustomersUrlV1}/${appId}/defaultTypes`);
  return response?.data;
}

export const getApplicationCustomerDefaultSeed = async (
  appId: number,
  customerId: number,
  defaultTypeId: number
) => {
  const response = await api.get<ApplicationCustomerDefaultSeed>(
    `${appCustomersUrlV1}/${appId}/customers/${customerId}/defaultSeed/${defaultTypeId}`
  );
  return response?.data;
};

export const createApplicationCustomerDefaultSeed = async (
  appId: number,
  customerId: number,
  defaultTypeId: number,
  success: boolean
) => {
  const response = await api.post<ApplicationCustomerDefaultSeed>(
    `${appCustomersUrlV1}/${appId}/customers/${customerId}/defaultSeed`,
    { defaultTypeId, success }
  );
  return response?.data;
};

export const initOpportunityDefaultMetrics = async (customerId: number) => {
  const response = await opportunityApi.post(`/v1/metrics/InitDefaults`, { customerId });
  return response;
};
